const SYSTEM_USER_IDS = new Set([
  'f6b6c089-4975-4c62-823d-13cf8b59dc50',
  'f75a9967-2e0a-42af-88e0-e9be8aea0fbd',
  '93e4aa48-0c4f-4d66-8b7b-e9865cb9b111',
]);
const SYSTEM_USERNAMES = new Set([
  'hingeadmin',
  'fortress',
  'hingeadmin4ELorg',
]);

export const SYSTEM_USER_DISPLAY_NAME = 'Fortress System Generated';

// An available ID is authoritative; usernames are only a fallback for partial responses.
export const isSystemUser = (user, userId = user?.id) =>
  userId ? SYSTEM_USER_IDS.has(userId) : SYSTEM_USERNAMES.has(user?.username);

export const getUserDisplayName = (user, humanDisplayName, userId) =>
  isSystemUser(user, userId) ? SYSTEM_USER_DISPLAY_NAME : humanDisplayName;
